﻿$.fn.dxCtrlTreeViewEmail = function custom_dxCtrlTreeViewEmail(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrltreeviewemail dx-ctrl");
        this.createInstance(new cdxCtrlTreeViewEmail(this, option));
    }
    return this;
}

window.cdxCtrlTreeViewEmail = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }
    if (typeof option.context_grid == 'undefined') option.context_grid = "grid_email_avec_classeur"

    var functionReconstruitWithoutReload = false
    option.bddCtrl.mAddFunctionOnModifiedItemData(["classeur","dates","tournee"], container,
        function (action, itemData) {
            functionReconstruitWithoutReload = true
            mConstruit()
            functionReconstruitWithoutReload = false
        })

    var dxTreeView = null;
    var selectedItem = null;
    function mConstruit(changeTextSearch) {
        if (typeof changeTextSearch == 'undefined') changeTextSearch = false
        var dxScrollTop = 0
        if (option.dxScrollParent) dxScrollTop = option.dxScrollParent.scrollTop()
        container.empty();

        var ds = []
        if (option.itemData.adresse_email == "Mailing email") {
            //MAILING
            ds = [{
                id: "c0",
                icon: "fas fa-chalkboard",
                text: "Tableau de bord mailing",
                selected: true,
                allowDrop: false
            }, {
                id: "c99",
                icon: "fas fa-square-envelope",
                text: "Mailing",
                is_envoi: true,
                lstIdTypeClassement: [7, 9, 12, 13],
                presentationMailing: true,
                idTypeCom: 2,
                allowDrop: false
                //items: [{
                //    id: "99_5",
                //    icon: "fas fa-square-envelope",
                //    icon2: "fas fa-bullseye",
                //    text: "Envoyés",
                //    is_envoi: true,
                //    lstIdTypeClassement: [12],
                //    presentationMailing: true,
                //    idTypeCom: 2
                //}, {
                //    id: "99_3",
                //    icon: "fas fa-square-envelope",
                //    text: "Envoi en cours",
                //    is_envoi: true,
                //    lstIdTypeClassement: [9, 13],
                //    presentationMailing: true,
                //    idTypeCom: 2
                //}, {
                //    id: "99_7",
                //    icon: "fas fa-square-envelope",
                //    icon2: "fas fa-pen",
                //    text: "Brouillons",
                //    is_envoi: true,
                //    lstIdTypeClassement: [7],
                //    presentationMailing: true,
                //    idTypeCom: 2
                //}]
            }]
            ds = ds.concat([{
                id: "c99_c5",
                parentId: "c99",
                icon: "fas fa-square-envelope",
                icon2: "fas fa-bullseye",
                text: "Envoyés",
                is_envoi: true,
                lstIdTypeClassement: [12],
                presentationMailing: true,
                idTypeCom: 2,
                allowDrop: false
            }, {
                id: "c99_c3",
                parentId: "c99",
                icon: "fas fa-square-envelope",
                text: "Envoi en cours",
                is_envoi: true,
                lstIdTypeClassement: [9, 13],
                presentationMailing: true,
                idTypeCom: 2,
                allowDrop: false
            }, {
                id: "c99_c7",
                parentId: "c99",
                icon: "fas fa-square-envelope",
                icon2: "fas fa-pen",
                text: "Brouillons",
                is_envoi: true,
                lstIdTypeClassement: [7],
                presentationMailing: true,
                idTypeCom: 2,
                allowDrop: false
            }])
            ds.push({
                id: "c9",
                icon: "fas fa-eye",
                text: "Tracking vue",
                lstIdTypeClassement: [],
                allowDrop: false
            })
            ds.push({
                id: "c10",
                icon: "fas fa-arrow-pointer",
                text: "Tracking click",
                lstIdTypeClassement: [],
                allowDrop: false
            })
            ds.push({
                id: "c7",
                icon: "fas fa-user-secret",
                text: "Email en désinscription",
                lstIdTypeClassement: [],
                allowDrop: false
            })
            ds.push({
                id: "c8",
                icon: "fas fa-ghost",
                text: "Email en bounce",
                lstIdTypeClassement: [],
                allowDrop: false
            })
        } else {
            //FAVORI OU adresse_email
            ds = [{
                id: "c1",
                text: "Boite de réception",
                icon: "fas fa-envelope-open",
                is_reception: true,
                expanded: true,
                selected: true,
                idTypeCom: 1,
                lstIdTypeClassement: [1],
                allowDrop: false
                //lstIdTypeClassement: [1, 2, 3, 4, 5, 6],
                //items: [{
                //    //    id: "1_1",
                //    //    icon: "fas fa-envelope-open",
                //    //    icon2: "fas fa-inbox",
                //    //    text: "En cours",
                //    //    selected: true,
                //    //    idTypeCom: 1,
                //    //    lstIdTypeClassement: [1]
                //    //}, {
                //    id: "1_2",
                //    icon: "fas fa-envelope-open",
                //    icon2: "fas fa-box-archive",
                //    text: "Archive",
                //    idTypeCom: 1,
                //    lstIdTypeClassement: [2]
                //}, {
                //    id: "1_3",
                //    icon: "fas fa-envelope-open",
                //    icon2: "fas fa-shield",
                //    text: "Spam",
                //    is_spam: true,
                //    idTypeCom: 1,
                //    lstIdTypeClassement: [3]
                //}, {
                //    //    id: "1_4",
                //    //    icon: "fas fa-envelope-open",
                //    //    icon2: "fas fa-person-circle-minus",
                //    //    text: "Liste grise",
                //    //    idTypeCom: 1,
                //    //    lstIdTypeClassement: [4]
                //    //}, {
                //    //    id: "1_5",
                //    //    icon: "fas fa-envelope-open",
                //    //    icon2: "fas fa-person-circle-exclamation",
                //    //    text: "Non délivré",
                //    //    idTypeCom: 1,
                //    //    lstIdTypeClassement: [5]
                //    //}, {
                //    id: "1_6",
                //    icon: "fas fa-envelope-open",
                //    icon2: "fas fa-person-walking-luggage",
                //    text: "Réponse automatique",
                //    idTypeCom: 1,
                //    lstIdTypeClassement: [6]
                //}]
            }, {
                id: "c2",
                icon: "fas fa-envelope",
                icon2: "fas fa-paper-plane",
                text: "Envoyés",
                is_envoi: true,
                idTypeCom: 2,
                lstIdTypeClassement: [8, 10, 12, 9, 13],
                allowDrop: false
                //lstIdTypeClassement: [10, 12, 8, 9, 11, 13],
                //items: [{
                //    //    id: "2_1",
                //    //    icon: "fas fa-envelope",
                //    //    icon2: "fas fa-paper-plane",
                //    //    text: "Envoyés",
                //    //    idTypeCom: 2,
                //    //    lstIdTypeClassement: [10]
                //    //}, {
                //    id: "2_1",
                //    icon: "fas fa-envelope",
                //    icon2: "fas fa-plane",
                //    text: "Envoyés sans tracking",
                //    idTypeCom: 2,
                //    lstIdTypeClassement: [10]
                //}, {
                //    id: "2_5",
                //    icon: "fas fa-envelope",
                //    icon2: "fas fa-bullseye",
                //    text: "Envoyés avec tracking",
                //    idTypeCom: 2,
                //    lstIdTypeClassement: [12]
                //}, {
                //    id: "2_2",
                //    icon: "fas fa-envelope",
                //    icon2: "fas fa-clock-rotate-left",
                //    text: "Envoi en attente",
                //    idTypeCom: 2,
                //    lstIdTypeClassement: [8]
                //}, {
                //    id: "2_3",
                //    icon: "fas fa-envelope",
                //    icon2: "fas fa-spinner fa-spin-pulse",
                //    text: "Envoi en cours",
                //    idTypeCom: 2,
                //    lstIdTypeClassement: [9, 13]
                //    //}, {
                //    //    id: "2_4",
                //    //    icon: "fas fa-envelope",
                //    //    icon2: "fas fa-triangle-exclamation",
                //    //    color2: "red",
                //    //    text: "Envoi en erreur",
                //    //    idTypeCom: 2,
                //    //    lstIdTypeClassement: [11]
                //}]
            }, {
                id: "c6",
                icon: "fas fa-envelope",
                icon2: "fas fa-pen",
                text: "Brouillon",
                idTypeCom: 2,
                lstIdTypeClassement: [7],
                allowDrop: false
            }]
            ds = ds.concat([{
                //    id: "1_1",
                //    icon: "fas fa-envelope-open",
                //    icon2: "fas fa-inbox",
                //    text: "En cours",
                //    selected: true,
                //    idTypeCom: 1,
                //    lstIdTypeClassement: [1]
                //}, {
                id: "c1_c2",
                parentId: "c1",
                icon: "fas fa-envelope-open",
                icon2: "fas fa-box-archive",
                text: "Archive",
                idTypeCom: 1,
                lstIdTypeClassement: [2]
            }, {
                id: "c1_c3",
                parentId: "c1",
                icon: "fas fa-envelope-open",
                icon2: "fas fa-shield",
                text: "Spam",
                is_spam: true,
                idTypeCom: 1,
                lstIdTypeClassement: [3],
                allowDrop: false
            }, {
                //    id: "1_4",
                //    icon: "fas fa-envelope-open",
                //    icon2: "fas fa-person-circle-minus",
                //    text: "Liste grise",
                //    idTypeCom: 1,
                //    lstIdTypeClassement: [4]
                //}, {
                //    id: "1_5",
                //    icon: "fas fa-envelope-open",
                //    icon2: "fas fa-person-circle-exclamation",
                //    text: "Non délivré",
                //    idTypeCom: 1,
                //    lstIdTypeClassement: [5]
                //}, {
                id: "c1_c6",
                parentId: "c1",
                icon: "fas fa-envelope-open",
                icon2: "fas fa-person-walking-luggage",
                text: "Réponse automatique",
                idTypeCom: 1,
                lstIdTypeClassement: [6],
                allowDrop: false
            }])
            ds = ds.concat([{
                //    id: "2_1",
                //    icon: "fas fa-envelope",
                //    icon2: "fas fa-paper-plane",
                //    text: "Envoyés",
                //    idTypeCom: 2,
                //    lstIdTypeClassement: [10]
                //}, {
                id: "c2_c1",
                parentId: "c2",
                icon: "fas fa-envelope",
                icon2: "fas fa-plane",
                text: "Envoyés sans tracking",
                idTypeCom: 2,
                lstIdTypeClassement: [10],
                allowDrop: false
            }, {
                id: "c2_c5",
                parentId: "c2",
                icon: "fas fa-envelope",
                icon2: "fas fa-bullseye",
                text: "Envoyés avec tracking",
                idTypeCom: 2,
                lstIdTypeClassement: [12],
                allowDrop: false
            }, {
                id: "c2_c2",
                parentId: "c2",
                icon: "fas fa-envelope",
                icon2: "fas fa-hourglass-half",
                text: "Envoi en attente",
                idTypeCom: 2,
                lstIdTypeClassement: [8],
                allowDrop: false
            }, {
                id: "c2_c3",
                parentId: "c2",
                icon: "fas fa-envelope",
                icon2: "fas fa-spinner",
                text: "Envoi en cours",
                idTypeCom: 2,
                lstIdTypeClassement: [9, 13],
                allowDrop: false
            }])
        }
        getClasseurDataTournee({ bddCtrl: option.bddCtrl }).mAddDsLstClasseur(ds, option.txtSearchClasseur)

        if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid][option.itemData.adresse_email] == 'undefined') {
            option.bddCtrl.utiCourantParaJson[option.context_grid][option.itemData.adresse_email] = { dsmenu: JSON.parse(JSON.stringify(ds)) }
            option.bddCtrl.mSaveParaJsonUtilisateur();
        }
        option.bddCtrl.utiCourantParaJson[option.context_grid][option.itemData.adresse_email].dsmenu.forEach(function (item) {
            var currentItem = ds.filter(function (o) { return ((o.id) ? o.id.toString() : o.id) == ((item.id) ? item.id.toString() : item.id) })[0]
            if (typeof currentItem != 'undefined') {
                currentItem.selected = ((typeof item.selected == 'undefined') ? false : item.selected)
                currentItem.expanded = ((typeof item.expanded == 'undefined') ? false : item.expanded)
            }
        })

        if (typeof option.id_type_classement != 'undefined' && option.id_type_classement != null) {
            lst = []
            ds.forEach(function (item) {
                lst.push(item)
                lst = lst.concat(mGetLstItemTreeview(item))
            })
            lst.forEach(function (item) {
                item.expanded = false
                item.Selected = false
                if (item.idTypeCom == 2 && item.idTypeClassement == option.id_type_classement) {
                    itemSelected = true
                }
                else if (item.id == "c2") { item.expanded = true }
            })
            delete option.id_type_classement
        }
        var itemElementPrecedentIsListe = false
        console.log(option.itemData)
        console.log(option.txtSearchClasseur)
        var firstLoad = true
        dxTreeView = $("<div/>").appendTo(container).dxTreeView({
            dataSource: ds,
            width: "100%",
            height: "100%",
            focusStateEnabled: true,
            dataStructure: 'plain',
            keyExpr: 'id',
            parentIdExpr: 'parentId',
            selectionMode: "single",
            //showCheckBoxesMode: true,
            onItemClick: function (e) {
                if (!e.itemData.id.startsWith("c999_")) { // != classeur
                    dxTreeView.selectItem(e.itemData)
                } else {
                    option.bddCtrl.utiCourantParaJson[option.context_grid][option.itemData.adresse_email].dsmenu = JSON.parse(JSON.stringify(e.component.option("dataSource")))
                    option.bddCtrl.mSaveParaJsonUtilisateur();
                }
            },
            onItemExpanded: function (e) {
                option.bddCtrl.utiCourantParaJson[option.context_grid][option.itemData.adresse_email].dsmenu = JSON.parse(JSON.stringify(e.component.option("dataSource")))
                option.bddCtrl.mSaveParaJsonUtilisateur();
            },
            onItemCollapsed: function (e) {
                option.bddCtrl.utiCourantParaJson[option.context_grid][option.itemData.adresse_email].dsmenu = JSON.parse(JSON.stringify(e.component.option("dataSource")))
                option.bddCtrl.mSaveParaJsonUtilisateur();
            },
            onItemSelectionChanged: function (e) {
                option.bddCtrl.utiCourantParaJson[option.context_grid][option.itemData.adresse_email].dsmenu = JSON.parse(JSON.stringify(e.component.option("dataSource")))
                option.bddCtrl.mSaveParaJsonUtilisateur();
                if (e.itemData.id.startsWith("c999_")) { //classeur
                } else {
                    e.component.element().find(".dx-treeview-item").css("background-color", "");
                    $(e.itemElement).css("background-color", theme.backgroundcolorAccentSelect);
                    Me.mSelect(e.itemData)
                    selectedItem = e.itemData
                }
            },
            itemTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.css("line-height", "0.9")
                itemElement.css("font-size", "90%")
                itemElement.closest(".dx-treeview-item").css("padding", "6px 8px")
                if (itemData.id.startsWith("c999_") || typeof itemData.id_classeur != 'undefined' || typeof itemData.id_tournee != 'undefined' || typeof itemData.id_dates != 'undefined') {
                    getClasseurDataTournee({ bddCtrl: option.bddCtrl }).mConstruitItemTreeview(
                        itemData,
                        itemElement,
                        false,
                        option.txtSearchClasseur,
                        true,
                        function (txtSearch) {
                            option.txtSearchClasseur = txtSearch
                            option.onChangeTexteSearchClasseur(option.txtSearchClasseur)
                            mConstruit(option.txtSearchClasseur.length > 0)
                        })
                } else {
                    if (itemData.id == "c9" || itemData.id == "c7" || itemData.id == "c0") {
                        itemElement.closest(".dx-treeview-item").css("border-top", theme.border)
                        //itemElement.closest(".dx-treeview-node").css("border-top", theme.border)
                        //itemElement.closest(".dx-treeview-node").css("padding-top", "5px")
                        if (itemData.id == "c99") itemElement.closest(".dx-treeview-node").css("padding-bottom", "5px")
                        itemElementPrecedentIsListe = true
                    } else {
                        if (itemElementPrecedentIsListe) {
                            itemElement.closest(".dx-treeview-node").css("padding-bottom", "5px")
                            itemElementPrecedentIsListe = false
                        }
                    }

                    var $Table = $("<table/>").appendTo(itemElement)
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:1px;font-size:160%;padding-right:5px;position:relative;'/>").appendTo($Tr)
                    var $Icone = $("<i class='" + itemData.icon + "' style='position:relative;'></i>").appendTo($Td);
                    if (typeof itemData.icon2 != 'undefined') {
                        var $Icone2 = $("<i class='" + itemData.icon2 + "' style='position:absolute;bottom:-1px;right:-1px;color:" + theme.backgroundcolorAccent + ";font-size:70%;'></i>").appendTo($Icone);
                        if (typeof itemData.color2 != 'undefined') $Icone2.css("color", itemData.color2)
                    }

                    switch (itemData.id) {
                        case "c1": //reception
                            itemElement.closest(".dx-treeview-item").addClass("isreception")
                            break;
                        case "c1_c3": //antispam
                            itemElement.closest(".dx-treeview-item").addClass("isantispam")
                            break;
                        case "c1_c2": //archivage
                            itemElement.closest(".dx-treeview-item").addClass("isarchivage")
                            break;
                    }

                    if (itemData.id != "c0" && !itemData.id.startsWith("c999_")) {
                        var $DivCompteur = $("<div style='padding:2px 4px 2px 3px;font-family:barlow condensed;position:absolute;top:-4px;left:-15px;font-size:60%;background-color:" + theme.backgroundColorCompteur + ";border-radius:5px;font-weight:500;display:none;color:" + theme.backgroundcolorTooltip + ";' class='count'></div>").appendTo($Td)
                        //var $DivCompteur = $("<div style='border-radius:50%;background-color:red;opacity:0.8;position:absolute;display:none;min-width:18px;top:-8px;left:-8px;' class='dx-theme-accent-as-text-color'><div style='border-radius:50%;padding:3px;font-weight:bold;background-color:red;font-size:50%;opacity:0.8;line-height:110%;text-align:center;'></div></div>").appendTo($Td)
                        var nb = 0
                        mUpdateCompteur()
                        $(window).on("changeNbEmail", function (e) { if (itemElement.closest("body").length > 0) mUpdateCompteur() });
                        function mUpdateCompteur() {
                            if ($DivCompteur.closest("body").length == 0) return
                            var oldNb = nb
                            var txtTooltip = ""
                            var color = ""
                            var classs = "blinkscalealwaysbig"
                            if (itemData.id == "c2" || itemData.id == "c2_c2") {
                                //on est sur les emails en attente
                                //on récupère les nb email en attente en erreur
                                color = "red"
                                nb = option.bddCtrl.msgEmailSms.mGetNbEmail([8], option.itemData.adresse_email.toLowerCase(), "-2")
                                txtTooltip = nb + " email" + ((nb > 1) ? "s" : "") + " en erreur"
                            }
                            if (itemData.id == "c99" || itemData.id == "c99_c3") {
                                color = "red"
                                nb = option.bddCtrl.msgEmailSms.mGetDsEmailErreur(null, true,itemData.lstIdTypeClassement).nb
                                txtTooltip = nb + " email" + ((nb > 1) ? "s" : "") + " en erreur"
                            } else if (itemData.id == "c2" || itemData.id == "c2_c3") {
                                color = "red"
                                nb = option.bddCtrl.msgEmailSms.mGetDsEmailErreur(option.itemData.adresse_email.toLowerCase(), false, itemData.lstIdTypeClassement).nb
                                txtTooltip = nb + " email" + ((nb > 1) ? "s" : "") + " en erreur"
                            } else if (itemData.id == "c1") {
                                classs = ""
                                color = theme.backgroundcolorTooltip
                                nb = option.bddCtrl.msgEmailSms.mGetNbEmail(itemData.lstIdTypeClassement, option.itemData.adresse_email.toLowerCase(), "1")
                                txtTooltip = nb + " email" + ((nb > 1) ? "s" : "") + " non lu" + ((nb > 1) ? "s" : "")
                            }
                            if (oldNb != nb) {
                                $DivCompteur.css("background-color", theme.backgroundColorCompteur)
                                $DivCompteur.addClass(classs)
                                if (nb > 999) { $DivCompteur.text("∾") }
                                else { $DivCompteur.text(nb) }
                                $DivCompteur.attr("title", txtTooltip)
                                $DivCompteur.css("display", ((nb == 0) ? "none" : ""))
                            }
                        }
                    }
                    //var opt = {
                    //    adrmail: option.itemData.adresse_email.toLowerCase(),
                    //    elem: $Td,
                    //    top: "-10px",
                    //    left: "-13px",
                    //    lstIdTypeClassement: itemData.lstIdTypeClassement,
                    //    nouveau: "1"
                    //}
                    //if (itemData.idTypeCom == 1) opt.nouveau = 1
                    //option.bddCtrl.msgEmailSms.mAddCtrlCompteur(opt)

                    var $Td = $("<td style='width:100%;white-space:nowrap;'>" + itemData.text + "</td>").appendTo($Tr)
                    if (option.itemData.adresse_email != "Favori" && option.itemData.adresse_email != "Mailing email" && (itemData.is_reception || itemData.is_envoi || itemData.is_spam)) {
                        var $Tr = $("<tr style='font-size:70%;font-style: italic;color:" + theme.toastWarning + ";'/>").appendTo($Table)
                        var $Td = $("<td style='width:100%;white-space:nowrap;opacity:0.5;' colspan='2'></td>").appendTo($Tr)
                        if (itemData.is_reception && option.itemData.reception_actif == "0") {
                            //$Tr.css("color", theme.toastWarning)
                            //var $Span = $("<div style='white-space:nowrap;width:fit-content;'>La réception est désactivée</div>").appendTo($Td)
                            //$Span.addClass("state-hover")
                            //$Span.on("click", function (e) {
                            //    e.stopPropagation()
                            //    option.bddCtrl.getObjet("compte_email", option.itemData.id_compte_email).objetMetier.mShowPopup({
                            //        id_utilisateur: option.bddCtrl.utiCourant.id_utilisateur,
                            //        idAccordion: 1
                            //    })
                            //})
                        } else if (itemData.is_envoi && itemData.id != "c99" && option.itemData.envoi_actif == "0") {
                            //$Tr.css("color", theme.toastWarning)
                            //var $Span = $("<div style='white-space:nowrap;width:fit-content;'>Le SMTP de l'adresse est désactivé</div>").appendTo($Td)
                            //$Span.addClass("state-hover")
                            //$Span.on("click", function (e) {
                            //    e.stopPropagation()
                            //    option.bddCtrl.getObjet("compte_email", option.itemData.id_compte_email).objetMetier.mShowPopup({
                            //        id_utilisateur: option.bddCtrl.utiCourant.id_utilisateur,
                            //        idAccordion: 2
                            //    })
                            //})
                        } else if (itemData.is_reception
                            && option.itemData.reception_derniere_erreur_cnx != null
                            && option.itemData.reception_derniere_erreur_cnx.length > 0 &&
                            option.itemData.reception_date_derniere_erreur_cnx != null) {
                            //erreur de connexion
                            $Tr.css("color", theme.toastWarning)
                            $Td.text("Erreur de réception " + option.itemData.reception_date_derniere_erreur_cnx.toDateIlya(true))
                            $Td.attr("title", parametre.nom + " a tenté de recevoir vos emails mais a rencontré une erreur en interrogeant le serveur. Cliquer et vérifier la configuration de la réception.")
                            $Td.addClass("state-hover")
                            $Td.on("click", function (e) {
                                e.stopPropagation()
                                option.bddCtrl.getObjet("compte_email", option.itemData.id_compte_email).objetMetier.mShowPopup({
                                    id_utilisateur: option.bddCtrl.utiCourant.id_utilisateur,
                                    idAccordion: 1
                                })
                            })
                        } else if (itemData.is_envoi
                            && option.itemData.envoi_derniere_erreur_cnx != null
                            && option.itemData.envoi_derniere_erreur_cnx.length > 0 &&
                            option.itemData.envoi_date_derniere_erreur_cnx != null) {
                            //erreur de connexion
                            $Tr.css("color", theme.toastWarning)
                            $Td.text("Votre SMTP est en erreur " + option.itemData.envoi_date_derniere_erreur_cnx.toDateIlya(true))
                            $Td.attr("title", parametre.nom + " a tenté d'envoyer des emails mais a rencontré une erreur en interrogeant le serveur. Cliquer et vérifier la configuration de l'envoi.")
                            $Td.addClass("state-hover")
                            $Td.on("click", function (e) {
                                e.stopPropagation()
                                option.bddCtrl.getObjet("compte_email", option.itemData.id_compte_email).objetMetier.mShowPopup({
                                    id_utilisateur: option.bddCtrl.utiCourant.id_utilisateur,
                                    idAccordion: 2
                                })
                            })
                        } else if (itemData.is_reception) {
                            $Tr.css("font-size", "70%")
                            $Tr.css("color", "")
                            var txtComplete = option.bddCtrl.getObjet(option.itemData).objetMetier.mGetLibConfig()
                            if (txtComplete.length > 0) $Td.html("(" + txtComplete + ")")
                        } else if (itemData.is_spam) {
                            $Tr.css("font-size", "70%")
                            //$Tr.css("color", ((option.itemData.reception_date_antispam == null) ? theme.toastWarning : theme.toastSuccess))
                            //var txtComplete = ((option.itemData.reception_date_antispam == null) ? "Filtre ANTISPAM désactivé" : "Filtre ANTISPAM activé")
                            //if (txtComplete.length > 0) $Td.html("(" + txtComplete + ")")
                        }
                    }
                    precItemElement = itemElement
                }

            },
            onContentReady: function (e) {
                console.log("contentReady treeview email")
                if (firstLoad) {
                    $(e.component.element().find(".dx-state-selected").children()[0]).css("background-color", theme.backgroundcolorAccentSelect);
                    if (e.component.getSelectedNodes().length == 0) {
                        Me.mSelect(ds[0])
                        selectedItem = ds[0]
                    } else if (selectedItem == null || (selectedItem!=null && selectedItem.id != e.component.getSelectedNodes()[0].itemData.id)) {
                        selectedItem = e.component.getSelectedNodes()[0].itemData
                        if (e.component.getSelectedNodes()[0].parent) { e.component.expandItem(e.component.getSelectedNodes()[0].parent.itemData) }
                        Me.mSelect(e.component.getSelectedNodes()[0].itemData)
                    }
                }


                if (changeTextSearch) {
                    //on expand tous les items des classeurs
                    getClasseurDataTournee({ bddCtrl: option.bddCtrl }).mUpdateForSearch(e.component)
                }

                if (firstLoad) {
                    firstLoad = false
                    new cSortableTreeviewClasseurDatesTournee({
                        bddCtrl: option.bddCtrl,
                        filter: ".dx-treeview-item", //
                        element: e.element,
                        dxTreeView: e.component,
                        allowDropInsideItem: true,
                        allowReordering: true
                    });

                    if (option.dxScrollParent) {
                        option.dxScrollParent.scrollTo(dxScrollTop)
                    }
                }
            }
        }).dxTreeView('instance');


        option.bddCtrl.mAddFunctionOnModifiedItemData("compte_email", container, function (action, itemData) {
            if (action == "modif" && itemData.adresse_email == option.itemData.adresse_email) {
                dxTreeView.option("dataSource", ds)
            }
        })
    }

    this.hasFocus = false;
    this.mFocusOut = function () {
        dxTreeView.element().find(".dx-treeview-item").css("background-color", "");
        this.hasFocus = false;
    }
    this.mFocusIn = function () {
        dxTreeView.option("selectedItem", selectedItem)
        this.hasFocus = true;
    }

    this.mSelect = function (itemDataMenu) {
        if (typeof option.onChange != 'undefined') option.onChange(option.itemData, itemDataMenu)
    }

    this.mGetItemDataMenu = function () {
        return selectedItem
    }

    this.element = function () { return container }

    mConstruit();
}